import { Injectable } from '@angular/core';

import { JHIM } from './base/jhim';
import { SAMService } from '../sam/sam.service';
import { SAMMessage } from '../sam/interfaces/sam-message';
import { JHIMMessage } from './interfaces/jhim-message';
import { CartService } from '../services/cart.service';
import { SearchDialogService } from '../gui/gui-dialogs/search-dialog/search-dialog.service';
import { ToastController } from '@ionic/angular';
import { ConfigService } from '../config.service';
import { I18NService } from '../services/i18n.service';

@Injectable({
  providedIn: "root",
})
export class JHIMService extends JHIM {
  get isRunning() {
    return this.status === "online";
  }

  constructor(
    public sam: SAMService,
    private cartSvc: CartService,
    private searchSvc: SearchDialogService,
    private toastController: ToastController,
    private i18nSvc: I18NService,
    private configSvc: ConfigService
  ) {
    super(sam);
  }

  onMessage(event: any) {
    const message = <JHIMMessage>JSON.parse(event.data);
    if (message.Destination === "GUI") {
      // catch jhim notifications
      if (
        message.Object === "JhimEvent" &&
        message.Method === "_notification"
      ) {
        const action = message.parms.Action;
        let toastMsg = null;
        let color = 'primary';

        switch (action) {
          case "SCANNER_CONNECTED":
            color = 'success';
            toastMsg = `<b>${this.i18nSvc.translate("jhim.scanner.connected")}</b>`;
            break;
          case "SCANNER_DISCONNECTED":
            color = 'danger';
            toastMsg = `<b>${this.i18nSvc.translate("jhim.scanner.disconnected")}</b>`;
            break;
        }

        if (message) {
          this.toastController.create({
            duration: 2000,
            position: 'top',
            message: toastMsg,
            color,
          }).then((toast) => toast.present());
        }
      }
    }

    if (message.Destination === "SAM") {
      // if search dialog open
      if (message.Object === "ScannerEvent" && message.Method === "barcode") {
        if (this.searchSvc.searchDialogOpen) {
          this.searchSvc.searchTerm = message.parms.Data;
          this.searchSvc.onSearch(this.searchSvc.searchTerm);
          return;
        }
      }

      // add qty when scanning via jhim
      if (message.Object === "ScannerEvent" && message.Method === "barcode") {
        message.parms.Qty = this.cartSvc.counters.qty;
        this.sam.socket.send(JSON.stringify(message));
        this.cartSvc.counters.qty = 1;
        return;
      }

      this.sam.socket.send(JSON.stringify(message));
    }
  }

  onDeviceSelect() {
    this.sam.onSend({
      Command: "CMD_SELECT_DEVICE",
    });
  }

  subscribeListeners() {
    this.sam.channels.network.subscribe((msg: SAMMessage) => {
      if (["SET_JHIM"].includes(msg.Command)) {
        let jhimAddress = msg.parms.Val;

        try {
          let [host, port] = jhimAddress.split(":");

          if (host === "*") {
            try {
              host = new URL(`http://${this.configSvc.samAddress}`).hostname;
            } catch (error) {
              host = window.location.hostname;
            }
          }

          jhimAddress = `${host}:${port}`;
        } catch (error) {
          
        }
        
        if (this.status === 'offline') { 
          this.connect(jhimAddress);
        }
      }
    });

    this.sam.channels.jhim.subscribe((msg: SAMMessage) => {
      this.onSend(<JHIMMessage>msg);
    });
  }
}
